import { render, staticRenderFns } from "./CardSeriesList.vue?vue&type=template&id=7dd1a885&"
import script from "./CardSeriesList.vue?vue&type=script&lang=ts&"
export * from "./CardSeriesList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports